import { useEffect, useState } from "react";
import { Trash2, Mail, Download } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { PageHeader } from "./AdminFaq";

function formatDate(s) { try { return new Date(s).toLocaleString("pt-PT"); } catch { return s; } }

export default function AdminNewsletter() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    async function load() {
        setLoading(true);
        try { const { data } = await api.get("/admin/newsletter"); setItems(data || []); }
        catch (err) { toast.error(formatApiError(err?.response?.data?.detail) || "Erro"); }
        finally { setLoading(false); }
    }
    useEffect(() => { load(); }, []);

    async function onDelete(it) {
        if (!window.confirm(`Remover ${it.email} da lista?`)) return;
        try { await api.delete(`/admin/newsletter/${it.id}`); toast.success("Removido"); load(); }
        catch (err) { toast.error(formatApiError(err?.response?.data?.detail) || "Erro"); }
    }

    function exportCsv() {
        const rows = [["email", "created_at"], ...items.map((i) => [i.email, i.created_at])];
        const csv = rows.map((r) => r.map((c) => `"${String(c).replace(/"/g, '""')}"`).join(",")).join("\n");
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url; a.download = `novifood-newsletter-${new Date().toISOString().slice(0, 10)}.csv`;
        a.click(); URL.revokeObjectURL(url);
    }

    return (
        <div data-testid="admin-newsletter-page">
            <div className="flex items-end justify-between gap-6 flex-wrap">
                <PageHeader title="Newsletter" subtitle="Subscritores via formulário do footer" count={items.length} />
                <button onClick={exportCsv} data-testid="newsletter-export" disabled={items.length === 0}
                    className="inline-flex items-center gap-2 rounded-md border border-border bg-white px-4 py-2.5 text-sm font-semibold hover:bg-muted disabled:opacity-50">
                    <Download className="h-4 w-4" /> Exportar CSV
                </button>
            </div>

            <div className="mt-8 rounded-2xl border border-border bg-white overflow-hidden">
                {loading ? (
                    <div className="p-12 text-center text-muted-foreground">A carregar...</div>
                ) : items.length === 0 ? (
                    <div className="p-12 text-center text-muted-foreground">Sem subscritores ainda.</div>
                ) : (
                    <table className="w-full text-sm">
                        <thead><tr className="bg-muted/60 text-left">
                            <th className="px-5 py-3 font-bold text-xs uppercase tracking-wide">Email</th>
                            <th className="px-5 py-3 font-bold text-xs uppercase tracking-wide w-56">Subscrito em</th>
                            <th className="px-5 py-3 w-20 text-right"></th>
                        </tr></thead>
                        <tbody>
                            {items.map((it) => (
                                <tr key={it.id} className="border-t border-border hover:bg-muted/30">
                                    <td className="px-5 py-3"><span className="inline-flex items-center gap-2"><Mail className="h-4 w-4 text-muted-foreground" /> <strong>{it.email}</strong></span></td>
                                    <td className="px-5 py-3 text-muted-foreground">{formatDate(it.created_at)}</td>
                                    <td className="px-5 py-3 text-right"><button onClick={() => onDelete(it)} className="rounded-md p-2 text-red-600 hover:bg-red-50" aria-label="Apagar"><Trash2 className="h-4 w-4" /></button></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
